import { Component, OnInit } from '@angular/core';
import { CourseQuizService } from '../../../../api/Services/maintenance/course-quiz.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-courses-quiz-title',
  templateUrl: './courses-quiz-title.component.html',
  styleUrls: ['./courses-quiz-title.component.css']
})
export class CoursesQuizTitleComponent implements OnInit {

  Form: FormGroup;
  constructor(
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private courseQuizServices: CourseQuizService,
    public dialogRef: MatDialogRef<CoursesQuizTitleComponent>
  ) { }

  ngOnInit(): void {

    this.initForm();
  }

  public initForm() {
    this.Form = this.formBuilder.group({
      coquti_tx_description: [null, Validators.required],
    });
  }

  SaveQuizTitle(){

    this.courseQuizServices.InsertQuizTitle(this.Form.getRawValue()).subscribe(
      data => {
       
        if (data['sucess']) {
         
          let result = data['data'][0];
          console.log(result);
          this.dialogRef.close();
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );

  }

}
